import React from "react";
import * as styles from "./AttendanceLayout.module.scss";

interface AttendanceLayoutProps {
  children: React.ReactNode;
  imageSrc?: string | null;
  imageAlt?: string;
  warning?: boolean;
}

const AttendanceLayout: React.FC<AttendanceLayoutProps> = ({
  children,
  imageSrc,
  imageAlt = "Ilustración",
  warning = false,
}) => {
  return (
    <div className={`${styles.layout} ${warning ? styles.warning : ""}`}>
      <div className={styles.actionContainer}>{children}</div>

      <aside className={styles.heroColumn}>
        <div className={styles.heroCircle}>
          <div className={styles.heroCircle}>
            {imageSrc && <img src={imageSrc} alt={imageAlt} className={styles.heroImage} />}
          </div>
        </div>
      </aside>
    </div>
  );
};

export default AttendanceLayout;
